import React, { useState, useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Loader from './component/Loader/Loader';
import NavBar from './component/NavBar/NavBar1';
import What from './component/What/What';
import Typesofwebsites from './component/Typesofwebsites/Typesofwebsites';
import Text from './component/Text/Text';
import Importance from './component/Importance/Importance';
import Hero from './component/Hero/Hero';
import Features from './component/Features/Features';
import Basiccomponents from './component/Basiccomponents/Basiccomponents';
import Example1 from './component/Example1/Example1';
import Call from './component/Call/Call';
import CardList from './component/CardList/CardList';
import Faq from './component/Faq/Faq';
import Contact from './component/Contact/Contact';
import Send from './component/Send/Send';
import Footer from './component/Footer/Footer';
import Whats from './component/Whats/Whats';
function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // محاكاة تحميل المحتوى لمدة 3 ثوانٍ
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App">
            {loading ? <Loader /> :
    <>
     <NavBar />
     <Hero />
     <What />
     <Typesofwebsites />
     <Text />
     <Features />
     <Basiccomponents />
     <Importance />
     <Example1/>
     <Call />
     <CardList />
     <Faq />
    <Contact />
    <Send />
    <Footer />
    <Whats />
    </>
    }
    </div>
  );
}

export default App;



 

